import React, { FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import PollabProgressLayout from '../../ProgressLayout'
import { TestID } from '../../../utils/PropTypesDefinitions'
import SmallTeaserHeadlineFont from '../../../Theme/Fonts/SmallTeaserHeadline'

export type PollabBaseOptionProps = {
    /** string to determine a text of the label */
    label: string
    /** string to determine the result text block */
    result?: string
    /** boolean to determine if the element was toggled before */
    selected?: boolean
    /** boolean to determine if element should react on onPress() */
    disabled?: boolean
    /** number (0% < x < 100%) to determine the width of the progress bar */
    percent?: number
    /**
     * callback when the user pressed on the component
     *
     * @TJS-type function
     */
    onPress?: () => void
} & TestID

const PollabBaseOption: FunctionComponent<PollabBaseOptionProps> = ({
    label,
    result,
    selected,
    disabled,
    onPress,
    percent,
    testID,
}) => {
    const touchable = !disabled && onPress

    const component = (
        <PollabProgressLayout progress={percent} testID={!touchable ? testID : undefined}>
            <Grid horizontal centerVertical noExpand>
                {selected ? (
                    <FontelloIcon color="onyx" name="check-active" paddingRight={3} />
                ) : null}
                <Grid paddingRight={4}>
                    <SmallTeaserHeadlineFont bold={selected}>{label}</SmallTeaserHeadlineFont>
                </Grid>
                {result ? (
                    <Grid noExpand alignRight>
                        <SmallTeaserHeadlineFont bold={selected} textAlign="right">
                            {result}
                        </SmallTeaserHeadlineFont>
                    </Grid>
                ) : null}
            </Grid>
        </PollabProgressLayout>
    )

    if (touchable) {
        return (
            <Touchable onPress={onPress} pointer testID={testID}>
                {component}
            </Touchable>
        )
    }
    return component
}

export default memo(PollabBaseOption)
